// import $ from 'jquery';

import './home';
import './details';
